import React from 'react';
import styled, { css } from 'styled-components';
import { TControlSize } from '../../tokens/types';
import { flexCenterAll, showInPrintOnly } from '../../styles/mixins';
import { RADIO_SIZES } from './HBRadioButton.types';
import { vars } from '../../theme';

// Due to a problem with Radio visibility, this is a solution for pdf printing.

export interface Props {
    size: TControlSize;
    color: string;
    checked: boolean;
}

const MockPrintRadioButton = ({ size, color, checked }: Props) => {
    return (
        <OuterCircle size={size} color={color} checked={checked}>
            <InnerCircle size={size} checked={checked} />
        </OuterCircle>
    );
};

export default MockPrintRadioButton;

// -------------------------------- Styles -------------------------------- //
const OuterCircle = styled.div<{
    size: TControlSize;
    color: string;
    checked: boolean;
}>`
    align-self: center;
    ${flexCenterAll}
    ${showInPrintOnly('flex')}
    width: ${({ size }) => RADIO_SIZES[size].outerCircle};
    height: ${({ size }) => RADIO_SIZES[size].outerCircle};
    border-radius: ${vars.radius.full};
    border: 1px solid;
    border-color: ${vars.colors.text.tertiary};

    ${({ checked, color }) =>
        checked &&
        css`
            background: ${color || vars.colors.text.primary};
            border-color: ${color || vars.colors.text.primary};
        `};
`;

const InnerCircle = styled.div<{ size: TControlSize; checked: boolean }>`
    width: ${({ size }) => RADIO_SIZES[size].innerCircle};
    height: ${({ size }) => RADIO_SIZES[size].innerCircle};
    border-radius: ${vars.radius.full};
    background: ${vars.colors.surface.item};
    opacity: ${props => (props.checked ? 1 : 0)};
`;
